<ion-card class="menu">
  <div class="card-content">
    @if (enableSidebarMenu) {
      <ion-card-header>
        <ion-buttons class="ion-padding-start">
          <ion-title>WaiterNow</ion-title>
          <ion-button>
            <img class="waiternow-img-logo" src="../../../../../assets/icons/icon-1024x1024.png">
          </ion-button>
        </ion-buttons>
      </ion-card-header>
    }
    <ion-card-content class="ion-card-content">
      @if (business) {
        <div class="location-header">
          <img class="location-img-logo" [src]="getLogoUrl()">
          <h1>
            {{ business.name }}
          </h1>
        </div>
      }
      <ion-list mode="ios" (click)="handleClick()">
        @if (isUserLoggedIn()) {
          <ion-item lines="none" routerLink="/main/menu" routerLinkActive="selected" routerDirection="root">
            <ion-icon name="restaurant-outline" slot="start"></ion-icon>
            <ion-label class="ion-text-wrap">
              {{ 'Menu' | translate }}
            </ion-label>
          </ion-item>
          @if (isDev()) {
            <ion-item lines="none" routerLink="/main/menueditor" routerLinkActive="selected" routerDirection="root">
              <ion-icon name="restaurant-outline" slot="start"></ion-icon>
              <ion-label class="ion-text-wrap">
                {{ 'MenuEditor' | translate }}
              </ion-label>
            </ion-item>
          }
          <ion-item lines="none" routerLink="/main/salesreport" routerLinkActive="selected" routerDirection="root">
            <ion-icon name="document-text-outline" slot="start"></ion-icon>
            <ion-label class="ion-text-wrap">
              {{ 'SalesReport' | translate }}
            </ion-label>
          </ion-item>

          <ion-item lines="none" routerLink="/main/ordersreport" routerLinkActive="selected" routerDirection="root">
            <ion-icon name="document-text-outline" slot="start"></ion-icon>
            <ion-label class="ion-text-wrap">
              {{ 'OrdersReport' | translate }}
            </ion-label>
          </ion-item>
          <ion-item lines="none" routerLink="/main/business-hours" routerLinkActive="selected" routerDirection="root">
            <ion-icon name="time-outline" slot="start"></ion-icon>
            <ion-label class="ion-text-wrap">
              {{ 'BusinessHours' | translate }}
            </ion-label>
          </ion-item>
        } @else {
          <ion-item lines="none" (click)="switchLanguage()">
            <ion-icon name="earth" slot="start"></ion-icon>
            <ion-label> {{ 'Title-language' | translate }} </ion-label>
          </ion-item>
          <ion-item lines="none" routerLink="/feedback">
            <ion-icon name="chatbox-ellipses-outline" slot="start"></ion-icon>
            <ion-label>{{ 'Feedback' | translate }}</ion-label>
          </ion-item>
          <ion-item  lines="none" routerLink="/about">
            <ion-icon name="information-circle-outline" slot="start"></ion-icon>
            <ion-label> {{ 'Title-about' | translate }} </ion-label>
          </ion-item>
        }

      </ion-list>
    </ion-card-content>
  </div>
  <div class="card-footer">
    <ion-list mode="ios">
      <ion-item lines="none" (click)="about()">
        <ion-icon name="information-circle-outline" slot="start"></ion-icon>
        <ion-label class="ion-text-wrap"> {{ 'Title-about' | translate }} </ion-label>
      </ion-item>
      @if (isUserLoggedIn()) {
        <ion-item lines="none" (click)="logout()">
          <ion-icon name="log-out-outline" slot="start"></ion-icon>
          <ion-label class="ion-text-wrap"> {{ 'Log-out' | translate }}</ion-label>
        </ion-item>
      }
    </ion-list>
  </div>
</ion-card>